module.exports = __webpack_public_path__ + "components/weather-icon/static/dayrainshowers-688a3baff1fa9b05285011529332324f.png";